module.exports = __webpack_public_path__ + "e0fb34cf1c8251813f8e854a80fd4685.svg";